import Vue from 'vue'
import App from './App.vue'
import store from './store'

import Vuesax from 'vuesax'
import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap/dist/js/bootstrap.bundle.js';
import 'vuesax/dist/vuesax.css';

import './style.css';

Vue.use(Vuesax, {});

Vue.config.productionTip = false

new Vue({
  store,
  render: h => h(App),
}).$mount('#app')
